import { Input, Select } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    overflow: hidden;
    padding: 18px 20px 0 20px;
`

export const Content = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const UserForm = styled.form`
    width: 100%;
    margin-top: 28px;
`

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 24px;
    gap: 8px;
`

export const FormLabel = styled.div`
    font-size: var(--font-size-normal);
    color: var(--color-black);
    line-height: 36px;
    height: 36px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const FormInput = styled(Input)`
    width: 100%;
`
